import ajax from 'iss/utils/ajax';

export function log(error, stack) {
    return ajax.postJson("/log", {error: error, stack: stack});
}



// WEBPACK FOOTER //
// ./modules/issFrontend/service/LogService.js